import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableHead, TableRow, Chip, Pagination, CircularProgress, TextField,
  MenuItem, Button,
} from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import api from '../../api/axios';

const statusColors = { open: 'error', in_progress: 'warning', resolved: 'success', closed: 'default' };
const priorityColors = { high: 'error', medium: 'warning', low: 'default' };

export default function TicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get('/superadmin/tickets', { params: { page, limit: 15, status: statusFilter || undefined } });
    setTickets(data.data); setTotal(data.pagination.total); setLoading(false);
  }, [page, statusFilter]);

  useEffect(() => { load(); }, [load]);

  const updateStatus = async (id, status) => {
    await api.patch(`/superadmin/tickets/${id}`, { status });
    load();
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>Support Tickets</Typography>

      <Card>
        <CardContent>
          <TextField select size="small" label="Status" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} sx={{ mb: 2, width: 160 }}>
            <MenuItem value="">All</MenuItem>
            {['open', 'in_progress', 'resolved', 'closed'].map(s => <MenuItem key={s} value={s}>{s.replace('_', ' ')}</MenuItem>)}
          </TextField>

          {loading ? <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box> : (
            <Table size="small">
              <TableHead><TableRow>
                <TableCell>Tenant</TableCell><TableCell>Subject</TableCell>
                <TableCell>Priority</TableCell><TableCell>Status</TableCell>
                <TableCell>Date</TableCell><TableCell>Actions</TableCell>
              </TableRow></TableHead>
              <TableBody>
                {tickets.map(t => (
                  <TableRow key={t.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600}>{t.tenant_name}</Typography>
                      <Typography variant="caption" color="text.secondary">{t.user_name}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{t.subject}</Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.message}</Typography>
                    </TableCell>
                    <TableCell><Chip label={t.priority} size="small" color={priorityColors[t.priority]} /></TableCell>
                    <TableCell><Chip label={t.status.replace('_', ' ')} size="small" color={statusColors[t.status]} /></TableCell>
                    <TableCell><Typography variant="caption">{new Date(t.created_at).toLocaleDateString('en-PK')}</Typography></TableCell>
                    <TableCell>
                      <TextField select size="small" value={t.status} onChange={e => updateStatus(t.id, e.target.value)} sx={{ width: 130 }}>
                        {['open', 'in_progress', 'resolved', 'closed'].map(s => <MenuItem key={s} value={s}>{s.replace('_', ' ')}</MenuItem>)}
                      </TextField>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Pagination count={Math.ceil(total / 15)} page={page} onChange={(_, v) => setPage(v)} color="primary" />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
